import logger from '../../../utils/logger';
// taxData.js
// Loads and exports raw and parsed TAX_BRACKETS and DEDUCTIONS from public/data/taxData.json.

let TAX_BRACKETS = {};
let DEDUCTIONS = {};
let PARSED_TAX_BRACKETS = {};
let isLoaded = false;

// Helper: parse rate and range strings into numeric objects
function parseBrackets(rawBrackets, filingKey) {
  return rawBrackets.map((b) => {
    // Rate: "10%" → 0.10
    const rate = parseFloat(b.rate.replace("%", "")) / 100;
    // Range: "$X to $Y" or "$Z or more"
    const rangeStr = b[filingKey] || "";
    const cleaned = rangeStr.replace(/[$,]/g, "");
    const [low, high] = cleaned.split(" to ");
    const from = Number(low) || 0;
    const to =
      high && high.includes("or more") ? Infinity : Number(high) || Infinity;
    return { rate, from, to };
  });
}

/**
 * Loads taxData.json once, then returns:
 * {
 *   TAX_BRACKETS: raw bracket strings,
 *   DEDUCTIONS: raw deduction strings,
 *   PARSED_TAX_BRACKETS: { [year]: { single, married, head, marriedseparate } }
 * }
 */
export async function loadTaxData() {
  if (isLoaded) {
    return { TAX_BRACKETS, DEDUCTIONS, PARSED_TAX_BRACKETS };
  }

  try {
    const response = await fetch("/data/taxData.json");
    const data = await response.json();

    TAX_BRACKETS = data.TAX_BRACKETS || {};
    DEDUCTIONS = data.DEDUCTIONS || {};

    // Build numeric lookup tables
    for (const [year, brackets] of Object.entries(TAX_BRACKETS)) {
      PARSED_TAX_BRACKETS[year] = {
        single: parseBrackets(brackets, "single"),
        married: parseBrackets(brackets, "married"),
        head: parseBrackets(brackets, "head"),
        marriedseparate: parseBrackets(brackets, "marriedseparate"),
      };
    }

    isLoaded = true;
    return { TAX_BRACKETS, DEDUCTIONS, PARSED_TAX_BRACKETS };
  } catch (error) {
    logger.error("Failed to load tax data:", error);
    return { TAX_BRACKETS: {}, DEDUCTIONS: {}, PARSED_TAX_BRACKETS: {} };
  }
}

// Legacy exports for raw data
export { TAX_BRACKETS, DEDUCTIONS, PARSED_TAX_BRACKETS };
